import { render, staticRenderFns } from "./CalendarListItemSharingShareItem.vue?vue&type=template&id=0380407c&"
import script from "./CalendarListItemSharingShareItem.vue?vue&type=script&lang=js&"
export * from "./CalendarListItemSharingShareItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports